import {
  useHover
} from "./chunk-Z4WFRWXY.mjs";

// lib/components/toggle/toggle-button/toggle-button.tsx
import classNames from "classnames";
import { jsx } from "@emotion/react/jsx-runtime";
import { createElement } from "@emotion/react";
var ToggleButton = ({
  value,
  options,
  onClick,
  small,
  micro,
  className,
  ...buttonProps
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames("buttons mb-0 has-addons", className),
      style: { flexWrap: "nowrap" },
      children: options.map((option) => {
        return /* @__PURE__ */ jsx(
          OptionButton,
          {
            option,
            value,
            onClick,
            small,
            micro,
            ...buttonProps
          },
          option.value
        );
      })
    }
  );
};
var OptionButton = ({
  option,
  value,
  onClick,
  small,
  micro,
  ...buttonProps
}) => {
  const { hoverSensor, hovering } = useHover();
  const status = option.value === value ? "selected" : hovering ? "hovering" : "default";
  return /* @__PURE__ */ createElement(
    "button",
    {
      ...buttonProps,
      ...hoverSensor,
      key: value,
      type: "button",
      className: classNames(
        "button mb-0",
        styleClasses[option.color ?? "normal"][status],
        {
          "is-small": small || micro
        }
      ),
      style: {
        ...buttonProps.style,
        ...micro ? microStyle : {}
      },
      onClick: (e) => {
        e.preventDefault();
        onClick?.(option.value);
      }
    },
    option.label
  );
};
var microStyle = {
  fontSize: "0.8em",
  padding: "0.1em 0.75em",
  height: "24px"
};
var styleClasses = {
  normal: {
    default: "has-text-grey",
    hovering: "has-text-grey",
    selected: "has-text-info-dark has-background-info-light has-text-weight-semibold"
  },
  blue: {
    default: "has-text-grey",
    hovering: "has-text-grey has-background-info-light",
    selected: "has-text-info-dark has-background-info-light has-text-weight-semibold"
  },
  red: {
    default: "has-text-grey",
    hovering: "has-text-grey has-background-danger-light",
    selected: "has-text-danger-dark has-background-danger-light has-text-weight-semibold"
  },
  grey: {
    default: "has-text-grey",
    hovering: "has-text-grey has-background-grey-lighter",
    selected: "has-text-grey-dark has-background-grey-lighter has-text-weight-semibold"
  }
};

export {
  ToggleButton
};
